const setUtagDataForFdsDisplayType = (name) => {
	const { managedSortModels } = window.lp.pageData.sortFilter || {};
	if (managedSortModels?.[0]?.AttributeGroups) {

		const matchedAttr = managedSortModels?.[0]?.AttributeGroups.reduce(
			(attr, { Attributes }) => [ ...attr, ...Attributes ],
			[]
		).find(({ Name: attrName }) => attrName === name);
		if (matchedAttr?.DisplayType) {

			window.utag_data.fds_display_type = matchedAttr?.DisplayType;

		} else {

			const matchedAttrVar = managedSortModels?.[0]?.AttributeGroups.find(
				({ Name: attrName }) => attrName === name
			).Attributes;
			if (matchedAttrVar?.[0].DisplayType) {

				window.utag_data.fds_display_type = matchedAttrVar?.[0].DisplayType;

			}

		}

	}
};

export default setUtagDataForFdsDisplayType;
